import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Real RIPP Genesis renders (permanent Irys URIs from the collection).
const NFTS = [
  { n: "0001", name: "The Oracle", tier: "LEGENDARY", src: "https://gateway.irys.xyz/FVLRMZpaqLM1avdjfWnvBoQ12KGoK8CN7E2CVhFcxQto" },
  { n: "0002", name: "The Bull", tier: "EPIC", src: "https://gateway.irys.xyz/H6dWZFpz8VrATerzgJ2namLRkPXw7tG21UMoXrnhuaCs" },
  { n: "0003", name: "The Hunter", tier: "RARE", src: "https://gateway.irys.xyz/7mcdJRjhxqMxHprP1hrXsx8NBqUgcoo48Ss3PJ9H4ySE" },
  { n: "0004", name: "The Degen", tier: "UNCOMMON", src: "https://gateway.irys.xyz/DTgJV8LoWdRMyRqcmFgQK3nQiqpqPxy6P9BPvtbeCkYf" },
  { n: "0007", name: "The Bear", tier: "EPIC", src: "https://gateway.irys.xyz/AgbjM7tHsjqprzHnNcpd8UJXBqXds8h1THr13PN5Tc71" },
];
const TIER = { LEGENDARY: "#F5C451", EPIC: "#C084FC", RARE: "#38BDF8", UNCOMMON: "#4ADE80" };

export const NftShowcase = ({ testid = "nft-showcase" }) => {
  const [i, setI] = useState(0);
  const [hold, setHold] = useState(false);
  useEffect(() => {
    if (hold) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % NFTS.length), 3800);
    return () => clearInterval(t);
  }, [hold]);
  const it = NFTS[i];
  return (
    <div data-testid={testid} onMouseEnter={() => setHold(true)} onMouseLeave={() => setHold(false)}>
      <div className="relative aspect-square overflow-hidden rounded-2xl border border-white/10 bg-black">
        <AnimatePresence mode="sync">
          <motion.img key={it.n} src={it.src} alt={`RIPP #${it.n} ${it.name}`} data-testid={`${testid}-image`}
            initial={{ opacity: 0, scale: 1.04 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.9 }}
            className="absolute inset-0 h-full w-full object-cover" />
        </AnimatePresence>
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-black/90 to-transparent p-5">
          <div>
            <div className="font-mono text-[11px] tracking-[0.3em] text-white/50">RIPP GENESIS #{it.n}</div>
            <div className="mt-1 text-xl font-black text-white" data-testid={`${testid}-name`}>{it.name}</div>
          </div>
          <span className="rounded-full border px-3 py-1 font-mono text-[10px] tracking-widest" style={{ color: TIER[it.tier], borderColor: `${TIER[it.tier]}66` }} data-testid={`${testid}-tier`}>{it.tier}</span>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-5 gap-2">
        {NFTS.map((x, k) => (
          <button key={x.n} type="button" onClick={() => { setI(k); setHold(true); }} aria-label={`Show RIPP #${x.n} ${x.name}`} data-testid={`${testid}-thumb-${x.n}`}
            className={`overflow-hidden rounded-lg border transition-[border-color,opacity,transform] duration-300 hover:-translate-y-0.5 ${k === i ? "border-[#F5C451] opacity-100" : "border-white/10 opacity-60 hover:opacity-100"}`}>
            <img src={x.src} alt="" loading="lazy" className="aspect-square w-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};
